import './DnaModelAlert.scss'



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/DnaModelAlert/index.js